module.exports = __webpack_public_path__ + "/cf56ebb4b6b1282b3eda49fd01181103.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/notifications_icon.svg
 ** module id = 1626
 ** module chunks = 0
 **/